import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {initMatomo, trackPageView} from "../../../utils/Matomo/matomo";

export function MatomoTracker() {
  const location = useLocation();

  useEffect(() => {
    initMatomo();
  }, []);


  useEffect(() => {
    trackPageView();
  }, [location]);

  return null;
}
